import axiosHttp from "services/axiosHttp";
import { MEAL_BASE_URL } from "configs/AppConfig";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchMealTypeList = createAsyncThunk("fetchMealTypeList", async ({ page, limit, categoryType }, { rejectWithValue }) => {
	const params = new URLSearchParams({
		page: page,
		limit: limit,
		categoryType: categoryType,
	});

	try {
		const response = await axiosHttp.get(`${MEAL_BASE_URL}meal-types?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});

const MealTypeListSlice = createSlice({
	name: "MealTypeListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchMealTypeList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMealTypeList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});

		builder.addCase(fetchMealTypeList.rejected, (state, action) => {
			state.isLoading = false;

			if (action.error.message) {
				state.error = action.error.message;
			} else {
				state.error = "Unknown error occurred";
			}
		});
	},
});

export default MealTypeListSlice.reducer;
